var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68713 11.1029L1 15.1441V19.8588H15.731V15.1441L11.0439 11.1029",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.383 5.04118C12.383 2.8093 10.5843 1 8.3655 1C6.14668 1 4.34796 2.8093 4.34796 5.04118V7.73529C4.34796 9.96717 6.14668 11.7765 8.3655 11.7765C10.5843 11.7765 12.383 9.96717 12.383 7.73529V5.04118Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34796 5.71468C4.89033 5.60692 5.5934 5.41159 6.35673 5.04115C7.24729 4.61009 7.91018 4.10494 8.3655 3.69409",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3831 5.71467C11.526 5.82917 10.3743 5.89652 9.03511 5.71467C7.96377 5.56649 7.05982 5.30381 6.35675 5.04114",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7398 19.8587H25.1053V15.9994L21.2685 12.6924",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8894 12.6924L16.4006 13.1234",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3666 7.73525C22.3666 5.90883 20.8947 4.42822 19.0789 4.42822C17.2632 4.42822 15.7913 5.90883 15.7913 7.73525V9.93769C15.7913 11.7641 17.2632 13.2447 19.0789 13.2447C20.8947 13.2447 22.3666 11.7641 22.3666 9.93769V7.73525Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7913 8.2875C16.2399 8.19994 16.809 8.03829 17.4318 7.7352C18.1616 7.38497 18.704 6.96738 19.0723 6.63062",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3667 8.28752C21.6636 8.38182 20.7262 8.4357 19.628 8.28752C18.7509 8.16629 18.0143 7.95076 17.4385 7.73523",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffIcon);
export default __webpack_public_path__ + "static/media/StaffIcon.41510ec2d62ede84e463e9e114a81c4c.svg";
export { ForwardRef as ReactComponent };